export class InfoCpn {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido',
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton: {
                value: '',
                header: 'Ciudad:',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },

            compania: {
                value: '',
                header: 'Nombre de la compañía donde adquirió el bien:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Companía es requerida'
            },
            proyecto: {
                value: '',
                header: config.proyecto || 'Proyecto:',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 100,
                min: 3,
                required: 'Proyecto es requerido'
            },
            tipo_formulario: {
                value: null,
                header: 'Tipo de formulario:',
                required: 'Tipo de formulario es requerido'
            },
            tipo_solicitante: {
                value: null,
                header: 'Tipo de Solicitante:',
                required: 'Tipo de formulario es requerido'
            },
            tipo_identificacion: {
                value: null,
                header: 'Tipo de documento:',
                required: 'Tipo de formulario es requerido'
            },
            apellidos: {
                value: '',
                header: 'Apellidos completos:',
                required: 'Apellido es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            nombres: {
                value: '',
                header: 'Nombres completos:',
                required: 'Nombre es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            nombre_completo: {
                value: '',
                header: 'Nombre Completo',
                sort: true,
            },
            identificacion: {
                value: '',
                header: 'No. doc. Identidad:',
                required: 'No. doc. Identidad es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
            },
            nacionalidad: {
                value: null,
                header: 'Nacionalidad:',
                required: 'Nacionalidad es requerido.'
            },
            fecha_nacimiento: {
                value: null,
                header: 'Fecha de nacimiento (día/mes/año):',
                required: 'Fecha de nacimiento es requerido'
            },
            genero: {
                value: null,
                header: 'Género:',
                required: 'Género es requerido'
            },
            estado_civil: {
                value: null,
                header: 'Estado civil:',
                required: 'Estado civil es requerido'
            },
            grupo: {
                value: [],
                header: 'Empresas:',
                required: 'Seleccione por lo menos una'
            },
            empresa: {
                value: null,
                header: 'Empresa:',
                required: 'Empresa es requerido'
            },
            separacion_bienes: {
                value: null,
                header: 'Separación de bienes:',
                required: 'Separación de bienes es requerido'
            },
        }
    }

    optionLabel = 'nombre';
}
